var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-animation-renault"},[_c('div',{attrs:{"id":"canvas"}}),_vm._v(" "),_c('div',{staticClass:"gradient"},[_c('img',{attrs:{"src":_vm.background,"crossorigin":"anonymous"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }